{
  "01_Auf-Abgaenge": "Scale e ascensori",
  "01_Evakuation": "Evacuazione",
  "01_Gebote_Verbote": "Regole, divieti",
  "01_gefahren": "Pericoli Traffico",
  "01_Gleise": "Binari",
  "01_Richtungen": "Direzioni",
  "01_Verkehrsmittel": "Mezzo di trasporto",
  "010_Basic": "Base",
  "02_Brandbekaempfung": "Lotta contro gli incendi",
  "02_Entsorgung_Recycling": "Smalimento, reciclaggio",
  "02_Parkieren": "Parcheggiare",
  "02_Sektoren": "Settori",
  "02_verbote": "Divieti Traffico",
  "020_Arrow": "Freccie",
  "03_Barrierefreiheit": "Accessibilità",
  "03_gebote": "Obbligartori Traffico",
  "03_Hygiene": "Igiene",
  "03_vorschriftszeichen": "Segnali di prescrizione",
  "04_Dienstleistungen": "Servizi",
  "04_Funktionsweise": "Operazione",
  "04_Klassen": "Classi",
  "04_rest": "Resto Traffico",
  "06_richtzeichen": "Segnali indicativi",
  "080_Timetable": "Accessibilità",
  "10_zusatzzeichen": "Segnali aggiuntivi",
  "110_Location": "Posizione",
  "190_Installation": "Installazioni",
  "ab": "da",
  "Abbrechen": "Annulla",
  "Abmelden": "Esci",
  "Absenden": "Invia",
  "Achtung": "Attenzione",
  "admin_settings": "Impostazioni amministratore",
  "aerial": "Satellite",
  "Aktuelle Zoomstufe": "Livello di zoom corrente",
  "Aktueller Stand des Elements": "Livello corrente dell'elemento",
  "Alle Tags entfernen": "Rimuovere tutti i tag",
  "already in use for another drawing by this user.": "Nome già in uso.",
  "Als PNG speichern": "Scaricare come PNG",
  "Als Standardplan festlegen": "Impostare come piano predefinito",
  "Am rechten Rand andocken": "Ancora a destra",
  "andere": "altri",
  "Andocken lösen": "Rimuovi ancoraggio",
  "Änderungen konnten nicht gespeichert werden": "Impossibile salvare le modifiche",
  "Änderungen werden gespeichert": "Salvando modifiche",
  "Anfang Icon": "Icona iniziale",
  "Anfrage versenden": "Invia richiesta",
  "anfrage_form_success": "Grazie per la sua richiesta. Vi contatteremo al più presto.",
  "Anwenden": "Applicare",
  "Auf Ausschnitt zentrieren": "Centro sulla portata",
  "Auf Route zentrieren": "Zoom sul itinerario",
  "Auf Zoomstufen beschränken": "Limita al livello di zoom",
  "aufgaenge": "Ascensori e discese",
  "Auflösung": "Risoluzione",
  "Aus": "Disattivato",
  "Ausgewählte Elemente": "Elementi selezionati",
  "Ausrichtungshilfe": "Aiuto allineamento",
  "Ausschnitt festlegen": "Definire portata",
  "Ausschnitt sperren": "Bloccare la portata",
  "Ausser Zoomstufen Zoombeschränkung": "La restrizione di zoom selezionata è al di fuori dell'area attualmente visibile.",
  "bahnlinien": "Liniee ferroviarie",
  "bahnofplan": "Mappa delle stazioni",
  "Barrierefreie Route": "Percorso accessibile",
  "Baselayers": "Mappa di sfondo",
  "basemap": "Rete trafico",
  "Bearbeiten": "Modificare",
  "Benutzeranleitung": "Manuale d'uso",
  "Betreiber": "Gestore",
  "bike": "Bicicletta",
  "Bild einfügen": "Inserire un imagine",
  "Bild herunterladen": "Scaricare immagine",
  "bis": "fino a",
  "Bitte geben Sie einen Plannamen ein.": "Inserire un nome di piano.",
  "Bitte loggen Sie sich ein, um die Zeichnung zu exportieren.": "Si prega di accedere per esportare il disegno.",
  "Bitte, Copyright zu kopieren": "Dimensione dell'esportazione troppo piccola per visualizzare correttamente il copyright. Assicurati che il seguente copyright appaia nella tua pubblicazione:",
  "Branche": "Settore",
  "Bus": "Autobus",
  "bus": "Autobus",
  "buslinien": "Linee d'autobus",
  "Car": "Macchina",
  "car": "Macchina",
  "Coach": "Autocorriera",
  "coach": "Autocorriera",
  "colorful": "Mappa colorata",
  "Confirm remove plan": "Sei sicuro di voler rimuovere questo piano dal tuo profilo?",
  "Construction": "Cantiere",
  "Copyright kopiert!": "Copyright copiato!",
  "custom_layout_dialog_description": "Potete integrare ed esportare il vostro piano direttamente in mapset in un modello PDF. Progettiamo i modelli in base ai vostri desideri per quanto riguarda il formato, il logo e il corporate design, nonché la collocazione dei testi e di altri elementi. Inviateci un messaggio tramite questo modulo e vi contatteremo.",
  "custom_layout_dialog_title": "Creare un layout personalizzato",
  "custom_layout_placeholder_message": "Sono interessato/a a un layout PDF personalizzato. Contattatemi all'indirizzo {{user.email}}.",
  "custom_layout_placeholder_title": "Creare un layout di mapset per {{user.email}}",
  "Datenschutz": "Privacy",
  "Den bestehenden Plan können sie mit folgendem Link jederzeit weiter bearbeiten.": "Puoi modificare il piano esistente in qualsiasi momento con il seguente link.",
  "Der aktuelle Anmelde-Status hat sich geändert. Bitte laden Sie die Seite neu.": "Lo stato di accesso attuale è cambiato. Si prega di ricaricare la pagina.",
  "Der geladene Plan ist ein Standardplan. Sie haben keine Rechte, um Standard-Pläne zu bearbeiten.": "Il piano caricato è un piano predefinito. Non ha i diritti di modificare i piani predefiniti.",
  "Der Plan wurde geändert": "Il piano è stato modificato",
  "Dialog nicht mehr anzeigen": "Non mostrare più il dialogo",
  "Did you know?": "Lo sapevi?",
  "Die Zeichnung konnte nicht geladen werden.": "Non è stato possibile caricare il disegno.",
  "Die Zeichnung konnte nicht geladen werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.": "Non è stato possibile caricare il disegno. Controlla la connessione a Internet e riprova.",
  "Die zu exportierende Fläche ist zu groß. Die maximal zulässige Größe ist ": "L'area da esportare è troppo grande. La dimensione massima consentita è ",
  "Diese Pikto-Gruppe besteht aus": "Questo gruppo consiste di",
  "Dieser Plan wurde nicht von Ihnen erstellt. Was möchten Sie tun?": "Questo piano non è stato creato da lei. Come vuole procedere?",
  "Dieser Plan wurde ursprünglich nicht von Ihnen benannt. Durch Ihre Änderungen wird der Planname für andere User auch aktualisiert.": "Questo piano non è stato originariamente nominato da lei. Le modifiche apportate aggiorneranno il nome del piano anche per gli altri utenti.",
  "drawinfo.default_for": "Tipo di piano",
  "drawinfo.name": "Nome del piano",
  "drawinfo.provider": "Gestore",
  "drawinfo.station_identifier": "Id della stazione",
  "drawinfo.station_name": "Nome della stazione",
  "drawinfo.valid_from": "Valido da",
  "drawinfo.valid_to": "Valido fino a",
  "drawinfo.viewLinkValidity": "Validità del piano standard",
  "Drehung": "Rotazione",
  "Dreieck zeichnen": "Disegnare triangolo",
  "Ebene": "Strati",
  "Ebenen": "Strati",
  "editor_disabled_tooltip_picture": "disponibile solo a partire dal livello di zoom 15",
  "editor_group_area": "Disegnare superfici",
  "editor_group_line": "Disegnare linee",
  "editor_group_point": "Disegnare punti",
  "Eine Position nach oben": "Porta avanti",
  "Eine Position nach unten": "Sposta indietro",
  "Einloggen": "Accedi",
  "Einstellungen": "Impostazioni",
  "Element auswählen": "Selezionare l'elemento",
  "Element löschen": "Eliminare elemento",
  "Element wurde in die Zwischenablage kopiert": "L'elemento è stato copiato negli appunti.",
  "Elemente löschen": "Eliminare elementi",
  "Ende Icon": "Icona finale",
  "Entfernen": "Rimuovere",
  "Error": "Errore",
  "Etwas ist schief gelaufen.": "Qualcosa è andato storto.",
  "Events": "Eventi",
  "Export im geteilten Plan ermöglichen": "Abilitare l'esportazione nel piano condiviso",
  "Export Optionen": "Impostazioni esportazione",
  "export_kml_description": "Scaricate la planimetria in formato KML per utilizzarla in altri strumenti.\n\n<italic>Si noti che la rappresentazione della planimetria in KML può differire da quella di mapset.</italic>",
  "export_type_image": "Immagine",
  "export_type_kml": "KML",
  "export_type_pdf": "PDF",
  "export_width_too_small_message": "L'area da esportare è troppo piccola. Aumentare la larghezza della portata a {{width}} pixel per visualizzare correttamente tutti gli elementi del modello.",
  "Exportieren": "Esportare",
  "Externe kommerzielle Einrichtungen": "Installazioni commerciali externe",
  "Fallend": "Discendente",
  "Farbe ändern": "Modificare colore",
  "feature_styler_title_area": "Impostazioni superficie",
  "feature_styler_title_icon": "Impostazioni icona",
  "feature_styler_title_icon_group": "Impostazioni gruppo di pittogrammi",
  "feature_styler_title_label": "Impostazioni testo",
  "feature_styler_title_line": "Impostazioni linea",
  "feature_styler_title_picture": "Impostazioni immagine",
  "feature_styler_title_unknown": "Editor di stile",
  "feature_type_area": "Superficie",
  "feature_type_icon": "Pittogramma",
  "feature_type_icon_group": "Gruppo di pittogrammi",
  "feature_type_label": "Etichetta",
  "feature_type_line": "Linea",
  "feature_type_picture": "Immagine",
  "feature_type_unknown": "Elemento",
  "feedback_form_error": "Siamo spiacenti, non è stato possibile inviare il messaggio. Stiamo cercando di risolvere il problema il prima possibile.",
  "feedback_form_file_helper_text": "Formato accettato: {{formats}}",
  "feedback_form_success": "Grazie per il vostro feedback. Le daremo un riscontro il prima possibile.",
  "feedback_form_text": "Avete trovato un errore in mapset o avete un suggerimento per un miglioramento? Segnalatecelo utilizzando questo modulo.\n\nGli errori nella base della mappa sono meglio documentati direttamente in mapset disegnando la situazione corretta sulla mappa. Il disegno verrà automaticamente inviato come link. In alternativa, è possibile allegare una propria immagine.",
  "Ferry": "Traghetto",
  "ferry": "Traghetto",
  "File size too big": "Dimensioni del file troppo grandi, max. {{size}}MB.",
  "Fläche zeichnen": "Disegnare poligono",
  "Flächen-Transparenz": "Trasparenza superfice",
  "Flächenfarbe": "Colore superfice",
  "foot": "Piedi",
  "form_attachment": "Allegati",
  "form_message": "Messaggio",
  "form_title": "Oggetto",
  "Format": "Formato",
  "Fortschritt gespeichert": "Modifiche salvate",
  "Fortschritt speichern": "Salvare",
  "Fortschritt wird gespeichert": "Salvando modifiche",
  "Funicular": "Funicolare",
  "funicular": "Funicolare",
  "Für den Export von PDF-Layouts müssen Sie eingeloggt sein.": "Deve essere conesso per esportare layout PDF.",
  "Fussgänger": "Piedi",
  "fusswege": "Percorsi pedonali",
  "Ganzer Plan": "Tutto il piano",
  "gebirgsnamen": "Nomi delle montagne",
  "gewässerlabel": "Etichette corpi d'aqua",
  "Gondola": "Cabinovia",
  "gondola": "Cabinovia",
  "gross": "grande",
  "Grösse": "Dimensione",
  "Gruppierung aufheben": "Separa gruppo",
  "guide.customlayout": "pdftemplate",
  "guide.downloadplan": "downloadplan",
  "guide.drawarea": "drawarea",
  "guide.drawicon": "drawicon",
  "guide.drawlabel": "drawlabel",
  "guide.drawline": "drawline",
  "guide.drawroute": "drawroute",
  "guide.feedback": "feedback",
  "guide.insertpicture": "insertpicture",
  "guide.layertoggler": "layertoggler",
  "guide.newplan": "newplan",
  "guide.plandefault": "defaultplans",
  "guide.plannamesandlist": "plannamesandlist",
  "guide.plansaveconfirm": "saveplanconfirm",
  "guide.plansaving": "saveplan",
  "guide.plansharing": "plansharing",
  "guide.settings": "settings",
  "guide.tags": "plans-with-tags",
  "Halt entfernen": "Rimuovere fermata",
  "Halt hinzufügen": "Aggiungere fermata",
  "haltekanten": "Bordi delle fermate",
  "Haltestelle": "Fermata",
  "Haltestelle suchen": "Cercare fermata",
  "haltestellen": "Fermate",
  "haltestellenschilder": "Segnaletica delle fermate",
  "Hide at next startup": "Nascondi all'avvio successivo",
  "Hilfslinien": "Linee ausiliarie",
  "Hineinzoomen": "Ingrandire",
  "Hintergrundfarbe": "Colore di sfondo",
  "hoch": "alta",
  "Hochladen": "Selezionare i file",
  "hotkeys.featureDelete": "anche usando Canc o Backspace",
  "hotkeys.featureFreehand": "disegno a mano libera utilizzando Maiusc + tasto sinistro del mouse",
  "hotkeys.featureGroup": "anche usando Ctrl + G",
  "hotkeys.featureIconMultiselect": "selezione multipla tramite Ctrl + clic sull'icona",
  "hotkeys.featureUngroup": "anche usando Ctrl + Shift + G",
  "hotkeys.mapRotate": "ruotare la mappa utilizzando Alt + Maiusc + pan della mappa",
  "icone_trenord": "Icone Trenord",
  "Icons": "icone",
  "Icons suchen": "Cerca icone",
  "Ihre Änderungen konnten nicht gespeichert werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.": "Non è stato possibile salvare le modifiche. Controlla la connessione internet e riprova.",
  "Impressum": "Impronta",
  "Individuell": "Customizzabile",
  "Information zur Reisekette 1": "Informazioni di viaggio 1",
  "Information zur Reisekette 2": "Informazioni di viaggio 2",
  "Inspect-Modus": "Modo d'ispezione",
  "Interne kommerzielle Einrichtungen": "Installazioni commerciali interne",
  "Jetzt loslegen": "Inizia ora",
  "Kartenausrichtung zurücksetzen": "Ripristina rotazione mappa",
  "kein": "nessuno",
  "Kein Plan vorhanden. Bitte erstellen Sie zuerst einen Plan.": "Nessun piano disponibile. Per favore crea prima un piano.",
  "kein QR-Code": "Nessun codice QR",
  "Keine Icons gefunden.": "Nessuna icona trovata.",
  "Keine Pläne verfügbar.": "Nessun piano disponibile.",
  "klein": "piccolo",
  "Kontur-Transparenz": "Trasparenza contorno",
  "Konturbreite": "Larghezza contorno",
  "Konturfarbe": "Colore contorno",
  "Konturtype": "Tipo contorno",
  "Kopie": "copia",
  "Kopieren": "Copia",
  "Kopiertes Element wurde eingefügt": "L'elemento copiato è stato incollato.",
  "Kreis zeichnen": "Disegnare cerchio",
  "Kreuzweise": "Tratteggio",
  "Laden...": "Caricando...",
  "Lageplan": "Altri servizi",
  "landscape": "Orizzontale",
  "linee_trenord": "Linee Trenord",
  "Linie": "Linea",
  "Linie zeichnen": "Disegnare linea",
  "Linien-Transparenz": "Trasparenza",
  "Linienabschluss": "Fine linea",
  "Linienanfang": "Inizio linea",
  "Linienbreite": "Larghezza linea",
  "Linientyp": "Tipo linea",
  "Link kopiert!": "Link copiato!",
  "Link zum Bearbeiten": "Link per modificare",
  "Link zum Teilen": "Link per condividere",
  "mapset_layout_description": "Descrizione",
  "mapset_layout_description_placeholder": "<b>Descrizione</b> del piano ...",
  "mapset_layout_title": "Titolo",
  "mapset_layout_title_placeholder": "Titolo ...",
  "Maximale Anzahl an Haltestellen erreicht": "Numero massimo di fermate raggiunto",
  "Meine Vorlage": "Il mio layout",
  "Mit diesem Link können Sie den Plan jederzeit weiter bearbeiten. Um die jetzige Version zu behalten, speichern Sie bitte diesen Link und erstellen dann einen": "Con questo link puoi continuare a modificare il piano in qualsiasi momento. Per mantenere la versione corrente, salva questo link e crea un",
  "Mit dieser Aktion wird der aktuelle Plan entfernt und ein neuer Plan gestartet. Wollen Sie wirklich einen neuen Plan erstellen?": "Questa azione rimuove il piano corrente e avvia un nuovo piano. Vuoi veramente creare un nuovo piano?",
  "mittel": "media",
  "mostUsed": "Più usati",
  "Muster": "Motivo superfice",
  "Nach ganz oben verschieben": "Porta in primo piano",
  "Nach ganz unten verschieben": "Sposta in fondo",
  "Nach Tags filtern...": "Filtrare per tag...",
  "neuen Plan": "nuovo piano",
  "Neuen Plan anlegen": "Creare un nuovo piano",
  "Neuen Tag erstellen": "Creare nuovo tag",
  "Neuer Plan": "Nuovo piano",
  "neutrino": "Mappa neutra",
  "NewPlan": "Questa azione crea un nuovo piano. Vuoi davvero continuare?",
  "Next Tip": "Avanti",
  "none": "Altri",
  "Nordpfeil": "Freccia nord",
  "normal": "normale",
  "Nur durch Hilfslinien oder Ankerpunkten angeordnete Piktogramme behalten die Ausrichtung und Reihenfolge bei.": "Solo le icone disposte con linee ausiliarie o punti di ancoraggio mantengono l'orientamento e la sequenza.",
  "Öffnen": "Aprire",
  "Organisation": "Organizzazione",
  "Ort": "luogo",
  "Ort, Adresse, Haltestelle": "Luogo, indirizzo, fermata",
  "ortslabel": "Nomi dei luoghi",
  "Ortung im geteilten Plan ermöglichen": "Abilitare la localizzazione nel piano condiviso",
  "pärke": "Spazi verdi",
  "Pflichtfeld": "Campi obbligatori",
  "Piktogramm zeichnen": "Disegnare icona",
  "Piktogramm-Ankerpunkte": "Punti di ancoraggio icone",
  "Piktogramme": "pittogrammi",
  "Piktogramme gruppieren": "Aggruppare icone",
  "Piktogramme selektiert": "icone",
  "Piktogrammen": "icone",
  "Plan bearbeiten": "Modifica piano",
  "Plan benennen": "Nominare un piano",
  "Plan duplizieren": "Duplicare piano",
  "Plan entfernen": "Rimuova piano",
  "Plan exportieren": "Esportare piano",
  "Plan löschen": "Elimina piano",
  "Plan speichern": "Salvare il piano",
  "Plan teilen": "Condividere piano",
  "Plan überschreiben": "Sovrascrivere il piano",
  "Plan wechseln": "Cambiare piano",
  "Planliste": "Lista di piani",
  "Planname": "Nome del piano",
  "pois": "POIs",
  "portrait": "Verticale",
  "Previous Tip": "Precedente",
  "QR-Code": "Codice QR",
  "QR-Code herunterladen": "Scaricare codice QR",
  "Quadrat zeichnen": "Disegnare quadrato",
  "rail": "Treno",
  "Rauszoomen": "Rimpiccolire",
  "Route kann für dieses Verkehrsmittel nicht berechnet werden!": "L'itinerario non può essere calcolato per questo mezzo di trasporto!",
  "Route kreieren": "Creare itinerario",
  "Route wird berechnet...": "Caricando itinerario...",
  "Route zeichnen": "Disegnare itinerario",
  "Routen-Finder": "Ricerca itinerario",
  "Routenlänge": "Lunghezza dell'itinerario",
  "saturated": "Rete trafico saturata",
  "SavePlanMessage": "Puoi modificare il piano esistente in qualsiasi momento con il nome <b>{{name}}</b> o con il seguente link.",
  "schiffslinien": "Linee di traghetti",
  "Schliessen": "Chiudi",
  "Schreibgeschützt fortfahren": "Continuare in sola lettura",
  "Schriftkontur": "Contorno della scrittura",
  "sehr hoch": "molto alta",
  "seilbahnen": "Funivie",
  "Seite neu laden": "Ricarica la pagina",
  "selektieren": "Seleziona {{plan}}",
  "Serviceeinrichtungen": "Servizi",
  "Show tips at startup": "Mostra suggerimenti all'avvio",
  "Sicherheitseinrichtungen": "Sicurezza",
  "Sie haben": "Lei ha selezionato",
  "Sie müssen eingeloggt sein, um diese Funktion nutzen zu können.": "Deve essere conesso per utilizzare questa funzione.",
  "Sie müssen eingeloggt sein, um diese Funktion weiterhin nutzen zu können.": "Deve essere conesso per continuare a utilizzare questa funzione.",
  "Sie müssen erst einen Plan erstellen.": "Prima bisogna creare un piano.",
  "Sie sind zur Zeit nicht angemeldet. Melden Sie sich an um mit der Bearbeitung fortzufahren, oder erstellen Sie einen neuen Plan.": "Non sei loggato al momento. Accedi per continuare a modificare o crea un nuovo piano.",
  "Sie werden von allen geOps-Diensten abgemeldet.": "Ti disconnettiamo da tutti i servizi geOps.",
  "small": "piccola",
  "Snapping aktivieren": "Attivare snapping",
  "Speichern": "Salvare",
  "Sprache": "Lingua",
  "Standard": "Standard",
  "Standard plan ist bereit": "È possibile visualizzare <a href='{{defaultsUrl}}' {{linkAttributes}}>online</a> piano standard per un momento specifico, oppure <a href='{{defaultPrintUrl}}' {{linkAttributes}}>scaricarlo in formato PDF</a>.",
  "Standardplan öffnen": "Aprire piano predefinito",
  "Standort": "Localizzazione",
  "Stapelreihenfolge": "Ordine di sovrapposizione",
  "Start- und Endpunkte müssen unterschiedlich sein!": "I punti di inizio e di fine devono essere diversi!",
  "Steigend": "Ascendente",
  "strassen": "Nomi delle strade",
  "Subway": "Metro",
  "subway": "Metro",
  "Suche nach Plänen": "Ricerca di piani",
  "Suche nach Tags...": "Ricerca di tag...",
  "Sucheingabe löschen": "Cancella ricerca",
  "SwitchPlan": "Questa azione apre il piano <b>{{name}}</b>. Vuoi davvero continuare?",
  "Tag hinzufügen": "Creare nuovo tag \"{{name}}\"",
  "tag_add_confirmation": "Tag nuovamente creati saranno disponibili per gli altri membri del team. \n\n Siete sicuri di voler aggiungere il tag \"{{name}}\"?",
  "Tags": "Tags",
  "Text": "Testo",
  "Text hier eingeben": "Inserire testo qui",
  "Text zeichnen": "Disegnare testo",
  "Textausrichtung": "Allineamento testo",
  "Textfarbe": "Colore testo",
  "Tippen Sie, um neue Tags zu erstellen": "Toccare per creare nuovi tag",
  "Tram": "Tram",
  "tram": "Tram",
  "tramlinien": "Linee del tram",
  "tunnelbeschriftungen": "Etichette dei tunnel",
  "ubahnlinien": "Linee metropolitane",
  "Um alle Funktionen in mapset zu nutzen, benötigt ihre Organisation ein Abonnement für mapset. Wenden Sie sich dazu bitte an support@mapset.ch.": "Per utilizzare tutte le funzionalità di mapset, la vostra organizzazione deve avere un abbonamento a mapset. Contattare <a href='mailto:support@mapset.ch' {{linkAttributes}}>support@mapset.ch</a>.",
  "Unbenannter Plan": "Piano senza nome",
  "unterfuehrungen": "Aree sotterranee",
  "User abmelden": "Disconettere {{user.email}}",
  "Validity overlaps with another constrained default plan": "La validità si sovrappone a un altro piano predefinito per questa stazione",
  "Verkehrsmittel": "Mezzi di trasporto",
  "verkehrsmittel": "Mezzi di trasporto",
  "Verwenden Sie diesen Link, um den Plan an andere Leute weiterzugeben oder in andere Anwendungen einzubinden.": "Utilizza questo link per condividere il piano con altre persone o integrarlo con altre applicazioni.",
  "Vollflächig": "Oloedrico",
  "Vorschau": "Anteprima",
  "Weiter": "Continua",
  "Wenn Ihre Zeichnung fertig ist, klicken Sie auf das rote SBB-Icon, um die Zeichnung im SBB-Webkartenportal anzuzeigen und zu teilen.": "Al termine del disegno, cliccare sull'icona rossa delle FFS per visualizzare e condividere il disegno sul portale Web Map delle FFS.",
  "Willkommen in mapset": "Benvenuti a mapset",
  "Wollen Sie Ihren Plan überschreiben oder eine neue Version des Plans anlegen?": "Si desidera sovrascrivere il piano o creare una nuova versione del piano?",
  "Zeichnung in WKP anzeigen": "Aprire il disegno nel portale web delle cartine",
  "Zeichnung speichern": "Salvare il piano",
  "Zeichnung teilen": "Condividere piano",
  "Ziehen um die Reihenfolge zu ändern": "Trascina per cambiare l'ordine",
  "Zoom-Höchstwert": "Zoom massimale",
  "Zoom-Tiefstwert": "Zoom minimale",
  "Zoomstufen": "Livelli di zoom",
  "Zug": "Treno",
  "Zurück": "Indietro",
  "Zurück zum Plan": "Tornare al piano",
  "Zurücksetzen": "Resettare",
  "Dein Zugang zu dieser Organisation ist deaktiviert. Bitte wende dich an deinen Admin.": "Il suo accesso a questa organizzazione è disattivato. Si prega di contattare il suo admin.",
  "Die Testphase deiner Organisation ist abgelaufen. Bitte wende dich an deinen Admin.": "Il periodo di prova della sua organizzazione è scaduto. Si prega di contattare il suo admin.",
  "Die Testphase deiner Organisation ist abgelaufen. Wähle einen Plan, um weiterzuarbeiten.": "Il periodo di prova della sua organizzazione è scaduto. Scelga un piano per continuare.",
  "Die Einrichtung einer Organisation ist bald verfügbar.": "La configurazione di un'organizzazione sarà presto disponibile.",
  "Organisation einrichten": "Configura organizzazione",
  "Upgrade": "Upgrade"
}
